import React from 'react'

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-primary'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-12 col-lg-3 footer-widget footer-widget-about'>
              <div className='footer-widget__content'>
                <img src='/assets/images/logo/logo-white.png' alt='logo' className='mb-30' style={{ width: '120px', height: 'auto' }} />
                <p className='mb-10 text-white'>ul. Marszałkowska 126/134</p>
                <p className='mb-10 text-white'>00-008 Warszawa</p>
                <p className='mb-10 text-white'><a href='mailto:info@kreatlo.com' className='text-white'>info@kreatlo.com</a></p>
              </div>
            </div>

            <div className='col-sm-6 col-md-4 col-lg-2 footer-widget footer-widget-nav'>
              <h6 className='footer-widget__title'>O aplikacji</h6>
              <div className='footer-widget__content'>
                <nav>
                  <ul className='list-unstyled'>
                    <li><a href='/features'>Funkcje</a></li>
                    <li><a href='/get-quote'>Jak zainstalować wtyczkę</a></li>
                    <li><a href='/knowledge-base'>Baza wiedzy</a></li>
                    <li><a href='/blog'>Blog</a></li>
                    <li><a href='/pricing'>Cennik</a></li>
                  </ul>
                </nav>
              </div>
            </div>

            <div className='col-sm-6 col-md-4 col-lg-2 footer-widget footer-widget-nav'>
              <h6 className='footer-widget__title'>Oferta</h6>
              <div className='footer-widget__content'>
                <nav>
                  <ul className='list-unstyled'>
                    <li><a href='/cooperation#pricing'>Cennik</a></li>
                    <li><a href='/cooperation'>Współpraca</a></li>
                  </ul>
                </nav>
              </div>
            </div>

            <div className='col-sm-6 col-md-4 col-lg-2 footer-widget footer-widget-nav'>
              <h6 className='footer-widget__title'>Wsparcie</h6>
              <div className='footer-widget__content'>
                <nav>
                  <ul className='list-unstyled'>
                    <li><a href='mailto:help@kreatlo.com'>help@kreatlo.com</a></li>
                    <li><a href='/#faq'>FAQ</a></li>
                  </ul>
                </nav>
              </div>
            </div>

            <div className='col-sm-6 col-md-4 col-lg-2 footer-widget footer-widget-nav'>
              <h6 className='footer-widget__title'>Ochrona danych</h6>
              <div className='footer-widget__content'>
                <nav>
                  <ul className='list-unstyled'>
                    <li><a href='/terms'>Regulamin</a></li>
                    <li><a href='/privacy'>Polityka prywatności</a></li>
                  </ul>
                </nav>
              </div>
            </div>

            {/* <div className='col-sm-6 col-md-6 col-lg-3 footer-widget'> */}
            {/*  <h6 className='footer-widget__title'>Newsletter</h6> */}
            {/*  <div className='footer-widget__content'> */}
            {/*    <form className='footer-form'> */}
            {/*      <div className='form-group mb-20'> */}
            {/*        <input type='text' className='form-control' placeholder='Twój Adres Email' /> */}
            {/*        <button type='submit' className='footer-form__submit'> */}
            {/*          <i className='icon-arrow-right' /> */}
            {/*        </button> */}
            {/*      </div> */}
            {/*      <div className='custom-control custom-checkbox d-flex align-items-center mb-20'> */}
            {/*        <input type='checkbox' className='custom-control-input' id='terms' /> */}
            {/*        <label className='custom-control-label color-gray' htmlFor='terms'> */}
            {/*          Akceptuję politykę prywatności i warunki. */}
            {/*        </label> */}
            {/*      </div> */}
            {/*    </form> */}
            {/*  </div> */}
            {/* </div> */}
          </div>
        </div>
      </div>

      <div className='footer-secondary'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-sm-12 col-md-5 col-lg-5'>
              <div className='footer__copyrights'>
                <span className='fz-14'>&copy; 2025 Kreatlo, Wszelkie Prawa Zastrzeżone </span>
                <a className='fz-14 color-primary' href='https://jan-mat.pl'>jan-mat.pl</a>
              </div>
            </div>

            <div className='col-sm-12 col-md-5 col-lg-5 d-flex flex-wrap justify-content-end align-items-center'>
              <ul className='social-icons list-unstyled mb-0 mr-30'>
                <li><a href='#'><i className='fab fa-facebook-f' /></a></li>
                <li><a href='#'><i className='fab fa-instagram' /></a></li>
                <li><a href='#'><i className='fab fa-linkedin' /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
